import {
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';

const checkboxProperties = {
  binary: true,
  truValue: true,
  falseValue: false,
};
const customChipClassification = (f) => !!f.value ? 'verdadero' : 'falso';

export const PUBLIC_WORKS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'town',
    label: 'Municipio',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'category',
    label: 'Categoría',
  },
];

export const PUBLIC_WORKS_FILTERS = [
  {
    field: 'Aeropuertos',
    label: 'Aeropuertos',
    icon: 'flight_takeoff',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-airport',
    ],
  },
  {
    field: 'Estaciones',
    label: 'Estaciones',
    icon: 'train',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-station',
    ],
  },
  {
    field: 'Faros',
    label: 'Faros',
    icon: 'bolt',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-lighthouse',
    ],
  },
  {
    field: 'Presas',
    label: 'Presas',
    icon: 'waves',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-dam',
    ],
  },
  {
    field: 'Puentes',
    label: 'Puentes',
    icon: 'emoji_transportation',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-bridge',
    ],
  },
  {
    field: 'Túneles',
    label: 'Túneles',
    icon: 'subway',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-tunnel',
    ],
  },
];
